import { render, staticRenderFns } from "./SendWithdrawal.vue?vue&type=template&id=7fff208e&scoped=true"
import script from "./SendWithdrawal.vue?vue&type=script&lang=js"
export * from "./SendWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fff208e",
  null
  
)

export default component.exports